<div class="review-container">
    <div class="review-section">
        <h3>{{ 'permit.create.review.requester' | translate }}</h3>
        <div class="review-card">
            <div class="review-primary">{{ citizenName() }}</div>
            <div class="review-secondary" *ngIf="citizen?.email">{{ citizen.email }}</div>
            <div class="review-secondary" *ngIf="citizen?.phone">{{ citizen.phone }}</div>
        </div>
    </div>

    <div class="review-section">
        <h3>{{ 'permit.create.review.permit_type' | translate }}</h3>
        <div class="review-card">
            <div class="review-type-header">
                <i [ngClass]="selectedCategory?.icon || 'icon-folder'" class="category-icon"></i>
                <div>
                    <div class="review-primary">{{ localizedName(selectedType?.name) }}</div>
                    <div class="review-subtitle" *ngIf="typeSubtitle(selectedType)">{{ typeSubtitle(selectedType) }}</div>
                    <div class="review-secondary">{{ localizedName(selectedCategory?.name) }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="review-section">
        <h3>{{ 'permit.create.review.location' | translate }}</h3>
        <div class="review-card">
            <div class="review-primary" *ngIf="locationText">{{ locationText }}</div>
            <div class="review-primary muted" *ngIf="!locationText">{{ 'permit.create.review.no_location' | translate }}</div>
            <div class="review-secondary" *ngIf="location?.siteLocation">{{ location.siteLocation }}</div>
        </div>
    </div>

    <div class="review-section" *ngIf="formDataEntries.length">
        <h3>{{ 'permit.create.review.form_data' | translate }}</h3>
        <div class="review-card">
            <dl class="form-data-list">
                <ng-container *ngFor="let entry of formDataEntries">
                    <dt class="form-data-key">{{ entry.label }}</dt>
                    <dd class="form-data-value">{{ entry.value }}</dd>
                </ng-container>
            </dl>
        </div>
    </div>

    <div class="review-section" *ngIf="hasFee">
        <h3>{{ 'permit.create.review.fee' | translate }}</h3>
        <div class="review-card">
            <div class="fee-row">
                <span class="fee-amount" *ngIf="feeAmount != null">{{ feeAmount | currency: 'CAD' : 'symbol-narrow' : '1.2-2' }}</span>
                <span class="fee-timing">{{ feeTimingKey | translate }}</span>
            </div>
            <div class="review-secondary" *ngIf="feeDescription">{{ feeDescription }}</div>
            <!-- No card terminal at a counter: the permit is created unpaid and the agent records
                 the payment afterwards from the permit's Infos panel. -->
            <div class="fee-notice">
                <mat-icon class="fee-notice-icon">info</mat-icon>
                <span>{{ 'permit.create.review.fee_unpaid_notice' | translate }}</span>
            </div>
        </div>
    </div>

</div>
